import { supabase } from '@/lib/supabase';

export type GetOrgInvitationInput = {
  invitationToken: string;
};

export type GetOrgInvitationResult = Awaited<
  ReturnType<typeof getOrgInvitation>
>;

export const getOrgInvitation = async ({
  invitationToken,
}: GetOrgInvitationInput) => {
  const { data, error } = await supabase
    .from('org_member_invites')
    .select('*, org:orgs(*)')
    .eq('invitation_token', invitationToken)
    .single();

  if (error) {
    throw error;
  }

  return data;
};
